
import { useAppContext } from '../../AppContext';
import './Navbar.css';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { useTheme } from '../../contexts/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSignOutAlt, faSun } from '@fortawesome/free-solid-svg-icons';

type Props = {
  username: string;
}

const Navbar: React.FC<Props> = ({ username }) => {
  const { setUser, setCommerce } = useAppContext();
  const { theme, toggleTheme } = useTheme();

  const handleLogout = async () => {
    const confirm = window.confirm('¿Estás seguro de querer cerrar sesión?');
    if (!confirm) return;
    
    try {
      await signOut(auth);
      setUser(null);
      setCommerce(null);
      // Navigation will be handled automatically by the App component
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  }

  return (
    <nav className="app-header">
      <div className="app-logo">
        <span className="app-logo-text">
          biyuyo
        </span>
      </div>
      <div className="app-user">
        <button 
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
        </button>
        <span>{username}</span>
        <button 
          className='logout-button'
          onClick={handleLogout}
          aria-label="Cerrar sesión"
          >
          <FontAwesomeIcon icon={faSignOutAlt} />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;